<template>
  <div class="news-detail-page">
    <SideBar
      :groups="groups"
      :isSidebarOpen="isSidebarOpen"
      @toggle-sidebar="toggleSidebar"
      @close-sidebar="closeSidebar"
      @handle-logout="handleLogout"
    />
    <div class="main-content">
      <TopBar
        :source="tag"
        @toggle-sidebar="toggleSidebar"
        @selected="getSelected"
      />
      <div class="content-area">
        <Breadcrumb
          :items="[
            { text: 'News & Updates', link: '/news' },
            { text: newsDetail ? newsDetail.NewsTitle : 'Loading...' },
          ]"
        />

        <div v-if="isLoading" class="loading-container">
          <LoadingSpinner size="medium" color="blue" />
        </div>

        <div v-else-if="!newsDetail" class="error-container">
          <i class="material-icons">error</i>
          <p>News item not found.</p>
          <router-link to="/news" class="btn-flat blue-text">
            Back to News
          </router-link>
        </div>

        <div v-else class="news-detail-container">
          <SectionContainer>
            <div class="news-header">
              <h1 class="news-title">{{ newsDetail.NewsTitle }}</h1>
              <div class="news-meta">
                <span class="news-date">{{
                  formatDate(newsDetail.Created)
                }}</span>
              </div>
            </div>
            <div class="news-short">
              <p>{{ newsDetail.NewsShort }}</p>
            </div>

            <div
              class="news-content"
              v-html="newsDetail.NewsContent"
              ref="newsContent"
            ></div>

            <div class="news-actions">
              <router-link to="/news" class="btn-flat blue-text">
                <i class="material-icons">arrow_back</i> Back to News
              </router-link>
            </div>
          </SectionContainer>
        </div>
      </div>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router";
import config from "../config.js";
import SideBar from "./SideBar.vue";
import TopBar from "./TopBar.vue";
import AppFooter from "./AppFooter.vue";
import SectionContainer from "./SectionContainer.vue";
import Breadcrumb from "./Breadcrumb.vue";
import LoadingSpinner from "./LoadingSpinner.vue";
import "../assets/css/dashboard.css";

export default {
  name: "NewsDetail",
  components: {
    SideBar,
    TopBar,
    AppFooter,
    SectionContainer,
    Breadcrumb,
    LoadingSpinner,
  },  data() {
    return {
      newsDetail: null,
      groups: [],
      user: [],
      tag: [],
      isLoading: true,
      isSidebarOpen: false,
      usercookie: null,
    };
  },
  methods: {
    getToken() {
      return this.$cookies.get("arch-it-portal") || this.usercookie;
    },
    formatDate(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Return original if invalid

      const day = date.getDate();
      const month = date.toLocaleString("en-US", { month: "long" });
      const year = date.getFullYear();

      return `${day} ${month} ${year}`;
    },
    getNewsDetail() {
      this.isLoading = true;
      const newsId = this.$route.params.id;
      const token = this.getToken();

      axios
        .get(
          config.getApiUrl(`news-details/${newsId}`),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => {
          this.newsDetail = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching news details:", error);
          this.isLoading = false;
        });
    },
    getGroups() {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("group"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.groups = response.data));
    },
    getTag() {
      const token = this.getToken();
      axios
        .get(
          config.getApiUrl("get-tag"),
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : {}
        )
        .then((response) => (this.tag = response.data));
    },
    getUser() {
      let params = new URLSearchParams();
      params.append("user", this.usercookie);
      const token = this.getToken();
      axios({
        method: "post",
        url: config.getApiUrl("get-user"),
        data: params,
        ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
      }).then((response) => {
        this.loginStatus(response.data);
      });
    },
    loginStatus(userData) {
      if (
        !userData ||
        !userData.expire ||
        Number(userData.expire) < Math.floor(Date.now() / 1000)
      ) {
        router.push({
          name: "Login",
        });
      }
    },    handleLogout() {
      this.$cookies.remove("arch-it-portal");
      router.push({
        name: "Login",
      });
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      document.body.style.overflow = this.isSidebarOpen ? "hidden" : "";
    },
    closeSidebar() {
      this.isSidebarOpen = false;
      document.body.style.overflow = "";
    },
    getSelected(result) {
      window.open(result.value, "_blank");
    },
    handleResize() {
      if (window.innerWidth > 768 && this.isSidebarOpen) {
        this.closeSidebar();
      }
    },
    applyStylesToContent() {
      this.$nextTick(() => {
        if (this.$refs.newsContent) {
          const olElements = this.$refs.newsContent.querySelectorAll("ol");
          olElements.forEach((ol) => {
            ol.style.paddingLeft = "25px";
          });
        }
      });
    },
  },  created() {
    this.usercookie = this.$cookies.get("arch-it-portal");
    this.getUser();
    this.getGroups();
    this.getTag();
    this.getNewsDetail();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.applyStylesToContent();
  },
  updated() {
    this.applyStylesToContent();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.news-detail-page {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
  text-align: center;
}

.error-container i {
  font-size: 48px;
  color: #e0e0e0;
  margin-bottom: 15px;
}

.error-container p {
  font-size: 16px;
  color: #757575;
  margin-bottom: 20px;
}

.news-detail-container {
  max-width: 1000px;
  margin: 0 auto;
}

.news-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eaeaea;
}

.news-title {
  font-size: 2rem;
  color: #00205b;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.news-meta {
  display: flex;
  align-items: center;
  color: #757575;
  font-size: 0.9rem;
}

.news-date {
  padding-right: 15px;
}

.news-short {
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eaeaea;
  font-weight: 500;
}

.news-content {
  line-height: 1.6;
  color: #333;
}

.news-content :deep(p) {
  margin-bottom: 16px;
}

.news-content :deep(h2) {
  margin-top: 32px;
  margin-bottom: 16px;
  color: #00205b;
  font-size: 1.5rem;
}

.news-content :deep(a) {
  color: #1565c0;
  text-decoration: none;
}

.news-content :deep(a:hover) {
  text-decoration: underline;
}

.news-content :deep(ul) {
  margin-bottom: 16px;
  padding-left: 20px;
}

.news-content :deep(ol) {
  margin-bottom: 16px;
  padding-left: 25px !important;
}

.news-content :deep(li) {
  margin-bottom: 8px;
}

/* Additional selector to ensure ordered lists have 25px padding */
.news-detail-container .news-content ol {
  padding-left: 25px !important;
}

.news-content :deep(hr) {
  margin: 24px 0;
  border: 0;
  height: 1px;
  background-color: #eaeaea;
}

.news-actions {
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #eaeaea;
}

.btn-flat {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.3s ease;
  background-color: rgba(33, 150, 243, 0.05);
  font-weight: 500;
}

.btn-flat:hover {
  background-color: rgba(33, 150, 243, 0.15);
  transform: translateY(-2px);
}

.btn-flat i {
  font-size: 18px;
  margin-right: 6px;
}

@media (max-width: 768px) {
  .news-title {
    font-size: 1.5rem;
  }

  .news-detail-container {
    padding: 0 15px;
  }
}
</style>

<!-- Global styles for dynamic content -->
<style>
/* This targets ordered lists in the news content without scoping */
.news-content ol {
  padding-left: 25px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail.vue